export default __webpack_public_path__ + "static/media/health.b11f3fa6.jpeg";